<template>
    <div>
        <a-form :layout="formLayout" :form="form">
            <a-form-item
                label="姓名"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
                <a-input
                    :disabled="true"
                    v-decorator="[
            'name',
            {
              initialValue: name,
            }
          ]"
                />
            </a-form-item>

            <a-form-item
                label="身份证号"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
                <a-input
                    :disabled="true"
                    v-decorator="[
            'id_code',
            {
              initialValue: id_code,
            }
          ]"
                />
            </a-form-item>

            <a-form-item
                label="身份证正面"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
                <img  :src="real_name_positive"/>

            </a-form-item>


            <a-form-item
                label="身份证反面"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
                <img  :src="real_name_reverse"/>

            </a-form-item>



            <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
                <a-button type="primary" @click="handleSubmit">审核通过</a-button>
            </a-form-item>

            <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
                <a-button type="dashed" @click="bohui">驳回</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>
<script>
    import request from "../../utils/request";

    export default {
        data() {
            return {
                formLayout: "horizontal",
                form:this.$form.createForm(this),
                old: {},
                id_code: "",
                real_name_positive: "",
                real_name_reverse:'',
                name: "",
            };
        },
        mounted() {
            this.getData();
        },
        computed: {
            formItemLayout() {
                const { formLayout } = this;
                return formLayout === "horizontal"
                    ? {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 14 }
                    }
                    : {};
            },
            buttonItemLayout() {
                const { formLayout } = this;
                return formLayout === "horizontal"
                    ? {
                        wrapperCol: { span: 14, offset: 4 }
                    }
                    : {};
            }
        },
        methods: {
            getData(){
                request({
                    url: "/user/"+this.$route.query.the_id,
                    method: "get",
                    params: {}
                }).then(response => {
                    let data=response.data;
                    if(data.success){
                        // this.form.resetFields();
                        this.old=data.data;
                        this.id_code=data.data.id_code;
                        this.real_name_positive=data.data.real_name_positive;
                        this.real_name_reverse=data.data.real_name_reverse;
                        this.name=data.data.name;
                    }else{
                        this.$message.error(data.msg);
                    }
                });
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handlePreview(file) {
                this.previewImage = file.url || file.thumbUrl;
                this.previewVisible = true;
            },
            handleChange({ fileList }) {
                this.fileList = fileList;
            },
            handleFormLayoutChange(e) {
                this.formLayout = e.target.value;
            },
            bohui(){
              //驳回
                this.form.validateFields((err, values) => {
                    if (!err) {
                        request({
                            url: "/user/real_name/reject",
                            method: "post",
                            data: {
                                real_name_user_id:this.old.id
                            }
                        }).then(response => {
                            let data=response.data;
                            if(data.success){
                                this.$message.success(data.msg);
                                this.$router.push({path: '/user/manager/all_real_name'})
                            }else{
                                this.$message.error(data.msg);
                            }
                            console.log(response);
                        });

                    }
                });
            },
            handleSubmit(){
                this.form.validateFields((err, values) => {
                    if (!err) {
                        request({
                            url: "/user/real_name/pass",
                            method: "post",
                            data: {
                                real_name_user_id:this.old.id
                            }
                        }).then(response => {
                            let data=response.data;
                            if(data.success){
                                this.$message.success(data.msg);
                                this.$router.push({path: '/user/manager/all_real_name'})
                            }else{
                                this.$message.error(data.msg);
                            }
                            console.log(response);
                        });

                    }
                });
            },
        }
    };
</script>
